<template>
  <div class="dataProvider">
    <div class="dataProvider__header">
      <div>
        <p class="dataProvider__name">{{ name }}</p>
        <p class="dataProvider__website"><a :href="website" target="_blank" class="link--blue">{{ website }}</a></p>
      </div>

      <div>
        <p class="dataProvider__browse">&raquo; <router-link :to="'/search?providers=' + id" class="link">Browse all data</router-link></p>
      </div>
    </div>

    <div class="dataProvider__content">
      <p
        class="dataProvider__description"
        v-html="description ? description : 'Description is not available.'"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String, Boolean],
      default: false
    },
    name: {
      type: [Number, String, Boolean],
      default: false
    },
    website: {
      type: [String, Boolean],
      default: false
    },
    description: {
      type: [String, Boolean],
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.dataProvider {
  @include font('content--md', $white, 0.9);
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background-color: $bg-4;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
  }

  &__header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    @media screen and (min-width: $breakpointSm) {
      flex-direction: row;
    }
  }

  &__name {
    @include font('header--md', $white, 0.9);
    margin: 0;
    padding: 0;
  }

  &__website {
    margin: 0;
  }

  &__browse {
    margin: 0.25rem 0;

    @media screen and (min-width: $breakpointSm) {
      margin: 0;
    }
  }

  &__description {
    padding: 0;
    color: rgba($white, 0.8);
  }
}

</style>
